import { Component, computed, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, map, pairwise, startWith } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService } from '@core/theme/theme.service';

const SCROLL_THRESHOLD = 10;

@Component({
  selector: 'app-mobile-header',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './mobile-header.component.html',
  styleUrl: './mobile-header.component.scss',
})
export class MobileHeaderComponent {
  private theme = inject(ThemeService);

  /** Hidden while the sidebar has nothing to navigate to (no company created yet). */
  showHamburger = input(true);

  hamburgerClick = output<void>();
  isVisible = signal(true);

  themeIcon = computed(() =>
    this.theme.theme() === 'dark'
      ? { fontSet: 'uicon-rr', fontIcon: 'fi-rr-sun' }
      : { fontSet: 'uicon-rr', fontIcon: 'fi-rr-moon' },
  );

  toggleTheme(): void {
    this.theme.toggle();
  }

  constructor() {
    fromEvent(window, 'scroll', { passive: true })
      .pipe(
        map(() => window.scrollY),
        startWith(0),
        pairwise(),
        takeUntilDestroyed(),
      )
      .subscribe(([prev, curr]) => {
        if (curr <= 0) {
          this.isVisible.set(true);
        } else if (curr > prev + SCROLL_THRESHOLD) {
          this.isVisible.set(false);
        } else if (curr < prev) {
          this.isVisible.set(true);
        }
      });
  }
}
